import Ajax from "../ajax";
import QueryParam from '@javascripts/query_param';

export default class VidioToken {
  static postToken(url) {
    return new Promise((resolve, reject) => {
      let counter = 0;

      if (QueryParam.headerEnrichment() && !window.watchHe) {
        const token_check_interval = window.setInterval(() => {
          if (window.watchHe || counter > 10) {
            window.clearInterval(token_check_interval);

            VidioToken.initiatePostToken(url)
              .then(token => resolve(token))
              .catch(response => reject(response));
          }

          counter++;
        }, 200);
      } else {
        VidioToken.initiatePostToken(url)
          .then(token => resolve(token))
          .catch(response => reject(response));
      }
    });
  }

  static initiatePostToken(url) {
    return new Promise((resolve, reject) => {
      const headers = window.watchHe ? { 'X-Watch-He' : window.watchHe } : {};

      Ajax.postJSON({
        url: url,
        headers: headers,
        success(responseJSON) {
          resolve(responseJSON.token);
        },
        error() {
          reject('');
        }
      });
    });
  }
}
